import { useMutation } from '@tanstack/react-query';

import { axiosInstance } from '~/services';

import { API_ENDPOINT } from '~/constants';

import type { TypeApiResponse, TypeGetReceivingRequestCopyResponse } from '~/types/receive.types';

type CopyParams = {
  ownerCode: string;
  requestIds: string;
};

/**
 * [입고요청관리] 입고요청 복사 API
 */
const fetchReceivingRequestCopy = async ({ ownerCode, requestIds }: CopyParams) => {
  const { data } = await axiosInstance.get<TypeApiResponse<TypeGetReceivingRequestCopyResponse['data']>>(
    `${API_ENDPOINT.RECEIVE.GET_REQUEST_COPY}/${ownerCode}/request/copy`,
    { params: { requestIds } }
  );
  return data.data;
};

/**
 * [입고요청관리] 입고요청 복사 Mutation Hook
 * @description 에러 처리는 사용처에서 개별 처리 (특수 에러 코드별 dialog 표시)
 */
export const useGetReceivingRequestCopyMutation = () => {
  return useMutation({
    mutationFn: fetchReceivingRequestCopy,
    meta: { silent: true },
  });
};
